export var languageSelector = {
  parent: {
    text: 'LanguageSelector',
    configuration: {
      type: 'LANGUAGE_SELECTOR',
      position: '1'
    }
  },
  configuration: {
    type: 'LANGUAGE_SELECTOR',
    position: '1'
  },
  children: [{
    language: 'English',
    langCode: 'EN',
    langLocale: 'en-US'
  }, {
    language: 'English (India)',
    langCode: 'EN-IN',
    langLocale: 'en-IN'
  }, {
    language: 'English (UK)',
    langCode: 'EN-GB',
    langLocale: 'en-GB'
  }, {
    language: 'Español',
    langCode: 'ES',
    langLocale: 'es-419'
  }, {
    language: 'Türkçe',
    langCode: 'TR',
    langLocale: 'tr'
  }, {
    language: '한국어',
    langCode: 'KO',
    langLocale: 'ko'
  }]
};